import PropTypes from 'prop-types'

export const CHAMP_PLANS =
  'w-full rounded-lg bg-[rgba(118,118,128,0.12)] px-2.5 py-1.5 text-[13px] text-[#1d1d1f] outline-none focus:bg-white focus:ring-[3px] focus:ring-[#0a84ff]/35 dark:bg-white/10 dark:text-white'

export default function AttributeField({
  id,
  label,
  type,
  value,
  erreur,
  autoFocus = false,
  onChange,
  onEnter,
}) {
  if (type === 'boolean') {
    return (
      <input
        id={id}
        type="checkbox"
        aria-label={label}
        autoFocus={autoFocus}
        checked={value === true}
        onChange={e => onChange(e.target.checked)}
        className="h-4 w-4 cursor-pointer accent-[#0a84ff]"
      />
    )
  }
  return (
    <>
      <input
        id={id}
        aria-label={label}
        autoFocus={autoFocus}
        value={value ?? ''}
        inputMode={type === 'number' ? 'decimal' : undefined}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') onEnter?.()
        }}
        className={`${CHAMP_PLANS} ${erreur ? 'ring-[3px] ring-[#ff3b30]/35' : ''}`}
      />
      {erreur && <p className="mt-0.5 text-xs text-[#ff3b30]">{erreur}</p>}
    </>
  )
}

AttributeField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'boolean']).isRequired,
  value: PropTypes.any,
  erreur: PropTypes.string,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
}
